import moment from 'moment';
export const RENEW_AS_OF_NOW = 'RENEW_AS_OF_NOW';
export const REDIRECT_TO_PAGE_NOT_FOUND = 'REDIRECT_TO_PAGE_NOT_FOUND';
export const REDIRECT_TO_PAGE_FEATURE_UNAVAILABLE = 'REDIRECT_TO_PAGE_FEATURE_UNAVAILABLE';
export const HIDE_HELP_ABOUT_THIS_PAGE = 'HIDE_HELP_ABOUT_THIS_PAGE';
export const UPDATE_SEARCH_COLUMN = 'UPDATE_SEARCH_COLUMN';
export const CONSULT_NOW_TOGGLE = 'CONSULT_NOW_TOGGLE';

export function renewAsOfNow() {
  return (dispatch) => dispatch({ type: RENEW_AS_OF_NOW });
}
export function redirectToPageNotFound(shouldRedirectToPageNotFound) {
  return (dispatch) =>
    dispatch({
      type: REDIRECT_TO_PAGE_NOT_FOUND,
      data: shouldRedirectToPageNotFound,
    });
}
export function redirectToPageFeatureUnavailable(shouldRedirectToPageFeatureUnavailable) {
  return (dispatch) => {
    dispatch({
      type: REDIRECT_TO_PAGE_FEATURE_UNAVAILABLE,
      data: shouldRedirectToPageFeatureUnavailable,
    });
  };
}

export function hideHelpAboutThisPage(shouldHideHelpAboutThisPageTab) {
  return (dispatch) => {
    dispatch({
      type: HIDE_HELP_ABOUT_THIS_PAGE,
      data: shouldHideHelpAboutThisPageTab,
    });
  };
}

// Add underlying search: the search result is returned is based on org id but the current search filter can display different filter
export function updateSearchColumn(searchColumn) {
  return (dispatch) => {
    dispatch({ type: UPDATE_SEARCH_COLUMN, data: searchColumn });
  };
}
